import { render, staticRenderFns } from "./learningRankingList.vue?vue&type=template&id=86b5a706&scoped=true"
import script from "./learningRankingList.vue?vue&type=script&lang=js"
export * from "./learningRankingList.vue?vue&type=script&lang=js"
import style0 from "./learningRankingList.vue?vue&type=style&index=0&id=86b5a706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b5a706",
  null
  
)

export default component.exports